module.exports = __webpack_public_path__ + "static/media/competency_inactive.9b8bb6fc.svg";